import { apiGet, apiUpdate } from "../../API/Service/apiClient";

export const handleMainCategory_Get =
 async({setCategoryOptions,setSelectedOption}) => {
   
  try {      
    let data={page:1,limit:1000}   
    const resData = await apiGet("mainproduct",data);        
    const options = resData?.data?.map((cat) => ({
      value: cat.id,
      label: cat.mpname
    }));
    setCategoryOptions(options)
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    
  }
}

export const handleSubProduct_Get =
async({setItems,selectedOption,setLoading}) => {
  setLoading(true)  
  try {         
    let data={
      mpid:selectedOption?.value
    }
    const resData = await apiGet("sub-product",data);        
    const sortedCategories = resData?.data?.sort((a, b) => a.seqno - b.seqno);
    setItems(sortedCategories);
     
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false)
  }
}

export const handleSubmit_subProduct = async ({items,setIsLoading,setIsChanged}) => {
  setIsLoading(true);
  try {     
    let data={
      categories: items.map((item, index) => ({ id: item.id, seqno: index })),
      action: "reorder",
    }
    const resData = await apiUpdate("sub-product",data);
    alert("Order saved successfully!");
    setIsChanged(false);
  } catch (error) {
    console.error("Error saving order", error);
  } finally {
    setIsLoading(false);
  }
};